import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Dimensions, ScrollView } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import Divider from '../../divider/Divider';
import HorizontalFilterComp from './HorizontalFilterComp';
import TextInput from '../../textInput/TextInput';
import PendingCustomerTable from './PendingCustomerTable';
import ShimmerTable from '../customerDetailsTable/ShimmerTable';
import EmptyScreen from './EmptyScreen';
import { showRegisterCustomer } from '../utils';
const PendingApplicationScreen = ({ height, activeIndex, PendingCustomerData, pendingCustomerCount, pendingDataFetched = false, pendingRegisteredCustomerAction, registeredCustomerAction, pendingCustomerAction, trackPendingCustomerJourney, currentSearchContext, shareLinkAction, viewDetailsAction, shareLinkRef, registeredCustomerActionNrml, pendingRegisteredCustomerActionNrml, pendingCustomerActionNrml, triggerAction, }) => {
    const screenWidth = Dimensions.get('window').width;
    const [searchText, setSearchText] = useState('');
    const [dataCount, setDataCount] = useState(pendingCustomerCount);
    const [currentActiveTabIndex, setCurrentActiveIndex] = useState(activeIndex || 1);
    const [showRC, setShowRCustomer] = useState(showRegisterCustomer());
    useEffect(() => {
        if (currentSearchContext)
            setSearchText(currentSearchContext);
    }, [currentSearchContext]);
    const handleSearch = async (text) => {
        if (text?.includes('+') && text?.length < 4 && text?.length > 0)
            return;
        if (currentActiveTabIndex === 1) {
            await triggerAction({
                ...pendingCustomerAction,
                payload: {
                    searchContext: text,
                    ...pendingCustomerAction.payload,
                }
            });
        }
        else if (currentActiveTabIndex === 2) {
            await triggerAction({
                ...pendingRegisteredCustomerAction,
                payload: {
                    searchContext: text,
                    ...pendingRegisteredCustomerAction.payload,
                }
            });
        }
        else if (currentActiveTabIndex === 3) {
            await triggerAction({
                ...registeredCustomerAction,
                payload: {
                    searchContext: text,
                    ...registeredCustomerAction.payload,
                }
            });
        }
    };
    const clearTextSearchAction = () => {
        setSearchText('');
        if (searchText?.length > 0)
            handleSearch('');
    };
    const onTabPress = async ({ activeIndex }) => {
        if (currentActiveTabIndex === activeIndex)
            return;
        setCurrentActiveIndex(activeIndex);
        if (activeIndex === 1) {
            await triggerAction({
                ...pendingCustomerActionNrml,
                payload: {
                    searchContext: searchText,
                    ...pendingCustomerActionNrml.payload
                }
            });
        }
        if (activeIndex === 2) {
            await triggerAction({
                ...pendingRegisteredCustomerActionNrml,
                payload: {
                    searchContext: searchText,
                    ...pendingRegisteredCustomerActionNrml.payload,
                }
            });
        }
        else if (activeIndex === 3) {
            await triggerAction({
                ...registeredCustomerActionNrml,
                payload: {
                    searchContext: searchText,
                    ...registeredCustomerActionNrml.payload,
                }
            });
        }
    };
    const renderContent = () => {
        return (React.createElement(View, { style: { width: screenWidth - 290, paddingRight: screenWidth <= 1600 ? 10 : (screenWidth - 1590) } },
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(View, null,
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.H2S, label: 'Pending applications', color: ColorTokens.Grey_Night }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, label: 'Create & track loan applications in progress', color: ColorTokens.Grey_Charcoal })),
                showRC &&
                    React.createElement(View, null,
                        React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Register customer', onPress: async () => {
                                await triggerAction({
                                    ...trackPendingCustomerJourney,
                                    payload: {
                                        customerType: 'PENDING_REGISTRATION',
                                        value: PendingCustomerData?.data,
                                        ...trackPendingCustomerJourney.payload,
                                    }
                                });
                            }, isDisabled: false }))),
            React.createElement(View, { style: { marginVertical: 24 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false, style: { flexDirection: 'row', width: '100%' } },
                React.createElement(HorizontalFilterComp, { title: 'All', noOfItems: dataCount?.allCount || '0', selected: currentActiveTabIndex === 1 ? true : false, activeIndex: 1, onPress: onTabPress }),
                React.createElement(View, { style: { marginHorizontal: 12 } },
                    React.createElement(HorizontalFilterComp, { title: 'Registration pending', noOfItems: dataCount?.registrationPendingCount || '0', selected: currentActiveTabIndex === 2 ? true : false, activeIndex: 2, onPress: onTabPress })),
                React.createElement(HorizontalFilterComp, { title: 'Registration completed', noOfItems: dataCount?.registrationCompletedCount || '0', selected: currentActiveTabIndex === 3 ? true : false, activeIndex: 3, onPress: onTabPress })),
            React.createElement(View, { style: { marginRight: 10, marginTop: 24, width: '40%' } },
                React.createElement(TextInput, { state: InputStateToken.DEFAULT, alphaNumericSpace: true, type: InputTypeToken.SEARCH, keyboardType: KeyboardTypeToken.default, title: 'Search applications', needSearchIcon: true, onChangeText: (text) => {
                        if (text?.length !== searchText?.length) {
                            setSearchText(text);
                            handleSearch(text);
                        }
                    }, value: searchText, placeholder: `${screenWidth < 1100 ? 'Enter name or phone' : 'Search by name or phone number'}`, clearTextAction: clearTextSearchAction })),
            React.createElement(View, { style: { marginTop: 12 } },
                pendingDataFetched === true && PendingCustomerData?.data?.length > 0 && React.createElement(PendingCustomerTable, { data: PendingCustomerData?.data, trackPendingCustomerJourney: trackPendingCustomerJourney, currentActiveTabIndex: currentActiveTabIndex, currentPage: PendingCustomerData?.currentPage, totalPages: PendingCustomerData?.totalPages, currentPageCustomer: PendingCustomerData?.actualpageSize, searchText: searchText, pendingCustomerAction: pendingCustomerAction, pendingRegisteredCustomerAction: pendingRegisteredCustomerAction, registeredCustomerAction: registeredCustomerAction, shareLinkAction: shareLinkAction, viewDetailsAction: viewDetailsAction, triggerAction: triggerAction }),
                pendingDataFetched === true && (PendingCustomerData?.data?.length === 0 || !PendingCustomerData?.data) &&
                    React.createElement(EmptyScreen, { triggerAction: triggerAction, shareLinkAction: shareLinkRef, trackPendingCustomerJourney: trackPendingCustomerJourney }),
                pendingDataFetched === false && React.createElement(ShimmerTable, null))));
    };
    return (React.createElement(BoilerPlate, { height: height, backgroundColor: ColorTokens.White, bottomChildren: React.createElement(React.Fragment, null) }, renderContent()));
};
const styles = StyleSheet.create({});
export default PendingApplicationScreen;
